module.exports = __webpack_public_path__ + "img/prj01.f367e587.png";